(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["how-it-works"] && !Shopify.designMode) return;
  try {
    (function () {
    var section = document.querySelector('.hiw');
    if (!section) return;

    // Reduced motion → bail without flagging animation; CSS default
    // is full opacity, so steps render fully visible from the start.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.classList.add('hiw--animate');

    // Scroll-timeline-capable browsers (Chrome/Edge/Opera today,
    // Safari/Firefox soon) drive the linear fade via CSS. We still
    // register the IO fallback below — when scroll-timeline is
    // active, the @supports rule pins opacity to the animation,
    // so the .is-active class is a no-op cosmetically.
    if (!('IntersectionObserver' in window)) {
      section.querySelectorAll('.hiw__step').forEach(function (s) {
        s.classList.add('is-active');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-active');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    section.querySelectorAll('.hiw__step').forEach(function (s) { io.observe(s); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whats-inside"] && !Shopify.designMode) return;
  try {
    // What's inside scrolly — rAF-driven lerp from raw scroll
  // position to `--entry-p` (the package-descent driver), plus a
  // `.is-revealed` toggle that fires the time-based pin sequence
  // when the sticky stage engages and reverses it when the user
  // scrolls back up past that point. One init per root; multiple
  // roots can coexist on the same page.
  (function () {
    var roots = document.querySelectorAll('[data-scrolly-root]');
    roots.forEach(function (section) {
      if (section.__scrollyInit) return;
      section.__scrollyInit = true;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isMobile = function () { return window.matchMedia('(max-width: 860px)').matches; };

      function setStatic() {
        section.classList.add('is-static');
        section.style.setProperty('--entry-p', '1');
      }
      if (reduced) { setStatic(); return; }

      var targetEntry = 0, renderedEntry = 0;
      var SMOOTH = 0.18;
      var EPS = 0.0005;
      var rafId = null;

      function readTargets() {
        var rect = section.getBoundingClientRect();
        var viewportH = window.innerHeight;
        targetEntry = Math.max(0, Math.min(1, (viewportH - rect.top) / viewportH));
        // Sticky stage engages when the section top hits viewport top
        // (rect.top <= 0). Toggle `.is-revealed` both ways so pins
        // sequence out in reverse when the user scrolls back up,
        // before the package re-ascends to cover the waffle. Small
        // 4px hysteresis buffer prevents class-flap at the boundary.
        var revealed = section.classList.contains('is-revealed');
        if (!revealed && rect.top <= 0) {
          section.classList.add('is-revealed');
        } else if (revealed && rect.top > 4) {
          section.classList.remove('is-revealed');
        }
      }

      function tick() {
        var d = targetEntry - renderedEntry;
        if (Math.abs(d) < EPS) {
          renderedEntry = targetEntry;
          section.style.setProperty('--entry-p', renderedEntry.toFixed(4));
          rafId = null;
          return;
        }
        renderedEntry += d * SMOOTH;
        section.style.setProperty('--entry-p', renderedEntry.toFixed(4));
        rafId = requestAnimationFrame(tick);
      }

      function schedule() {
        if (isMobile()) { setStatic(); return; }
        section.classList.remove('is-static');
        readTargets();
        if (rafId === null) rafId = requestAnimationFrame(tick);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      readTargets();
      renderedEntry = targetEntry;
      section.style.setProperty('--entry-p', renderedEntry.toFixed(4));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
